import __ from "web/Layout/Translations";

import formatNumber from "web/utils/data/parser/number/formatNumber";

import rentableGroupCalculatorCopy from "../const/rentableGroupCalculatorCopy";
import classes from "./rentableGroupCalculatorTotalIncomeMessage.scss";

const { totalIncomeTooHigh } = rentableGroupCalculatorCopy;

interface IRentableGroupCalculatorTotalIncomeMessageProps {
  totalIncome: number;
}

const RentableGroupCalculatorTotalIncomeMessage = ({
  totalIncome,
}: IRentableGroupCalculatorTotalIncomeMessageProps) => {
  return (
    <div className={classes.root}>
      <p>
        {__(totalIncomeTooHigh)} {formatNumber(totalIncome)} {__("zł")}.
      </p>
    </div>
  );
};

export default RentableGroupCalculatorTotalIncomeMessage;
